"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAutoFocusDisabled = selectAutoFocusDisabled;
function selectAutoFocusDisabled(state) {
  return state.autoFocusDisabled;
}